import * as React from 'react';
import SupplierResetPasswordForm from '../supplier_reset_password_form/SupplierResetPasswordForm';
import { Layout, Row, Col, BackTop, Card } from 'antd';
import { withRouter } from 'react-router';
import { parseQueryParams } from '../../utils/DataAccessUtils';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';

const style = require('./SupplierResetPasswordPage.less');
const style2 = require('../../styles/blah.less');
const { Content } = Layout;

class SupplierResetPasswordPage extends React.Component<any, any> {
	render() {
		const params = parseQueryParams(this.props.location.search);
		const token = params.resetToken;
		return (
			<Content className="supplierResetPasswordPage" style={{ padding: '0 0.5em' }}>
				<LogOnMountWithStandardEventProperties eventType="visited supplier reset password page" />
				<BackTop />
				<Row align="middle" style={{ height: '100vh' }} justify="center" gutter={16}>
					<Card title="Choose a new password">
						<SupplierResetPasswordForm token={token} />
					</Card>
				</Row>
			</Content>
		);
	}
}

export default withRouter(SupplierResetPasswordPage);
